import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../../../components/general/general-component/abstruct-component/DeleteComponent'
import SectionTopOfTable from '../../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Table2 from '../../../../components/table/Table2'
import Warning from '../../../../components/general/general-component/warning-delete/Warning'
import { deleteSubCategory, loadSubCategories } from '../../../../store/Actions/ActionSubCategory'
import { ColumnSubCategory } from '../../../../components/general/general-component/columns-component/ColumnSubCategory'
import { VariableSubCategory } from './VariableSubCategory'
import AddSubCategory from './AddSubCategory'
import EditSubCategory from './EditSubCategory'
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader'

const SubCategory = () => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { sub_categories, loadingSubCategories } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableSubCategory()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [subcategoriesArr, setSubCategoriesArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...subcategoriesArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setSubCategoriesArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, subcategoriesArr]);
    useEffect(() => {
        if (sub_categories?.length >= 0) {
            setSubCategoriesArr(sub_categories)
        }
    }, [sub_categories]);
    useEffect(() => {
        dispatch(loadSubCategories())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteSubCategory(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openSubCategory = e => {
        e.preventDefault()
        setOpen(true)
    }
    const editStatus = (id, status) => {
        let newStatus;
        if (status === 1) {
            newStatus = 0
        } else {
            newStatus = 1
        }
        /*dispatch(blockUser(id, newStatus, setloadDel));*/
    }
    const { columns } = ColumnSubCategory(translate, warning, handleEdit, editStatus, langLocal)
    return (
        <>
            <>
                {/*<FilterUser translate={translate} />*/}
                <div className="div_table2" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative" }} >
                    <SectionTopOfTable langLocal={langLocal} title={translate('sub_categories')} titleBtn={translate('add-sub-category')} FunctionBtn={openSubCategory} />
                    {
                        loadingSubCategories == false ? (
                            <Table2 col={columns} roo={subcategoriesArr} />
                        ) : <InnerLoader />
                    }
                </div>
            </>
            {
                state.open && (
                    <AddSubCategory open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditSubCategory arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </>
    )
}

export default SubCategory
